import { PlayerColor } from '@colonist/game-states';
import { MechanicValidator } from './MechanicValidator.ts';
export class MechanicValidatorLongestRoad extends MechanicValidator {
    getLongestRoadPlayerState(player) {
        if (player == PlayerColor.None) {
            return {
                longestRoad: 0
            };
        }
        const longestRoadPlayerState = this.longestRoadState[player];
        if (longestRoadPlayerState === undefined) throw new Error(`No longestRoadPlayerState for player ${player}`);
        return longestRoadPlayerState;
    }
    getPlayerWithLongestRoadCard() {
        for(const key in this.longestRoadState){
            const playerColor = Number(key);
            const longestRoadPlayerState = this.getLongestRoadPlayerState(playerColor);
            if (longestRoadPlayerState.hasLongestRoad) return playerColor;
        }
        return PlayerColor.None;
    }
    doesBankHaveLongestRoadCard() {
        const playerWithLongestRoadCard = this.getPlayerWithLongestRoadCard();
        return playerWithLongestRoadCard == PlayerColor.None;
    }
    constructor(playerValidators, mapValidator, longestRoadState){
        super(playerValidators, mapValidator);
        this.longestRoadState = longestRoadState;
    }
}
